import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as echarts from 'echarts'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { EssEnergyGrowthTrendChartData } from '../types'
import { colorArray } from './config'


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data?: EssEnergyGrowthTrendChartData
}

const chart = ref()



watch(
  () => props.data,
  (newData: EssEnergyGrowthTrendChartData | undefined) => {
    if (chart.value && newData) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.setOption({
          xAxis: [
            {
              data: newData.xAxisData || [],
            },
          ],
          series: newData.seriesData?.map((series, index) => {
            return {
              ...chartOption.value.series[0],
              itemStyle: {
                borderRadius: [20, 20, 0, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: colorArray[index] ? colorArray[index] : colorArray[0] }, // 橙色
                  { offset: 1, color: 'rgba(255, 138, 36, 0)' },
                ]),
              },
              name: newData.seriesData ? newData.seriesData[index].name : series.name,
              data: newData.seriesData ? newData.seriesData[index].data : [],
            }
          }),
        })
      }
    }
  },
  { immediate: true, deep: true },
)

onMounted(() => {
  window.addEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
onUnmounted(() => {
  // 清理事件监听
  window.removeEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})

// ECharts 的配置项
const chartOption = computed(() => {
  return {
    // 提示框组件
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow', // 坐标轴指示器，坐标轴触发有效
      },
    },

    // 图例组件 (此图中没有，可以不配置或隐藏)
    legend: {
      show: false,
    },

    // 网格配置
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },

    // X 轴配置
    xAxis: {
      type: 'category',
      data: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
      axisLine: {
        show: false, // 不显示轴线
      },
      axisTick: {
        show: false, // 不显示刻度
      },
      axisLabel: {
        color: '#ccc', // 标签颜色
      },
    },

    // Y 轴配置
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#ccc',
      },
      axisLine: {
        show: false,
      },
      splitLine: {
        // 网格线
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#444',
        },
      },
    },

    // 系列列表
    series: [
      {
        name: '数据一',
        type: 'bar',
        barWidth: '20%', // 柱子宽度
        itemStyle: {
          borderRadius: [20, 20, 0, 0], // 顶部圆角
          // 柱子渐变色
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#24a4ff' }, // 亮蓝色
            { offset: 1, color: 'rgba(36, 164, 255, 0)' },
          ]),
        },
        // 根据图片模拟的数据
        data: [250, 250, 120, 210, 310],
      },
      {
        name: '数据二',
        type: 'bar',
        barWidth: '20%',
        itemStyle: {
          borderRadius: [20, 20, 0, 0],
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#ff8a24' }, // 橙色
            { offset: 1, color: 'rgba(255, 138, 36, 0)' },
          ]),
        },
        // 根据图片模拟的数据
        data: [370, 182, 250, 198, 250],
      },
    ],
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"100%","height":"100%"},
    ref_key: "chart",
    ref: chart
  }, null, 512))
}
}

})